// Возвращает время по казахскому времени

export const getTimeWithGMTKz = (): Date | number => {
    const date = new Date(Date.now());

    const differenceGMTTime = date.getTimezoneOffset() * 60 * 1000;

    return new Date(Date.now() + differenceGMTTime + 21600000);
};
